<dsh-multi-input-field
    *transloco="let t; scope: 'orders-field'; read: 'ordersField'"
    [formControl]="control"
    [label]="t('label')"
    [showIcons]="false"
></dsh-multi-input-field>
